/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function () {

  // jQuery(".ProductForm__AddToCart").click(function (e) {
  //   e.preventDefault();
  //   var custom_id = jQuery(".custom_id").val();
  //   var p_id = jQuery("select[name=id]").val();
  //   var is_Gift = jQuery(this).data("gift") ? true : false;
  //   let item_in_cart_already = false;
  //   var quantity = 1;

  //   if (custom_id) {

  //     jQuery.getJSON('/cart.js', function (cart) {

  //       let items = cart.items;

  //       for (var i = 0; i < items.length; i++) {
  //         if (items[i].variant_id == custom_id) {
  //           item_in_cart_already = true;
  //         }

  //       }

  //       if (item_in_cart_already == false) {
  //         jQuery.post('/cart/add.js', {
  //           items: [
  //             {
  //               quantity: quantity,
  //               id: custom_id
  //             },
  //             {
  //               quantity: quantity,
  //               id: p_id
  //             }

  //           ]
  //         }).done(function () {
  //           console.log(custom_id, is_Gift);
  //         });
  //         console.log(custom_id);
  //         console.log(custom_id);
  //         console.log(p_id);
  //       }
  //     });




  //   }
  //   else {
  //     jQuery.post('/cart/add.js', {
  //       items: [
  //         {
  //           quantity: quantity,
  //           id: p_id,
  //           properties: { "freeGift": 1 }
  //         }
  //       ]
  //     }).done(function () {
  //       var freeGiftAlreadyInCart = false;
  //       fetch('/cart.js', {
  //         method: 'GET',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         }
  //       }).then(response => {
  //         if (response.status === 200) {
  //           return Promise.resolve(response.json());
  //         } else {
  //           return Promise.reject(new Error(response.statusText));
  //         }

  //       }).then(response => {
  //         let filteredItems = response.items.filter((x) => { return x?.properties?.Offer === "Free Gift" });
  //         freeGiftAlreadyInCart = filteredItems.length > 0 ? true : false;
  //         if (is_Gift && !freeGiftAlreadyInCart) {
  //           jQuery(".gwp-overlay").addClass("is-visible");
  //           jQuery(".Modal--gwp").attr("aria-hidden", false);
  //         }
  //       });
  //     });
  //   }
  // });

  jQuery(document).on("click", ".gwp-close", function () {
    jQuery(".gwp-overlay").removeClass("is-visible");
    jQuery(".Modal--gwp").attr("aria-hidden", true);
  });

  // jQuery(document).on("click", ".gwp-gift", function () {
  //   jQuery(document).find(".gwp-gift").each(function () {
  //     jQuery(this).removeClass("selected");
  //   });
  //   jQuery(this).addClass("selected");
  // });

  jQuery(document).on("click", ".gwp-button-color", function(){
    jQuery(document).find(".gwp-gift").each(function () {
      jQuery(this).removeClass("selected");
    });
    jQuery(document).find(".gwp-button-color").each(function () {
      jQuery(this).removeClass("selected");
    });
    jQuery(this).closest(".gwp-gift").find(".gwp-image img").attr("data-srcset", jQuery(this).data("img")).attr("srcset", jQuery(this).data("img"));
    jQuery(this).closest(".gwp-gift").find(".gwp-options input").val(jQuery(this).data("varid"));
    jQuery(this).addClass("selected");
    jQuery(this).closest(".gwp-gift").addClass("selected");
  });

  jQuery(document).on("click", ".add-gift-to-cart", function (e) {
    e.preventDefault();
    if(!jQuery(document).find(".gwp-gift.selected input").val()){
      jQuery(document).find("p.select-error").show(0).delay(5000).hide(0);
      return;
    } else {
      jQuery(document).find("p.select-error").hide(0);
    }
    jQuery.post('/cart/add.js', {
      items: [
        {
          quantity: 1,
          id: jQuery(document).find(".gwp-gift.selected input").val(),
          properties: { "Offer": "Free Gift" }
        },
      ]
    }).done(function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if (response.status === 200) {
          return Promise.resolve(response.json());
        } else {
          return Promise.reject(new Error(response.statusText));
        }

      }).then(response => {
        document.querySelector("span.Header__CartDot").innerHTML = response.item_count;
      });

      jQuery(".gwp-overlay").removeClass("is-visible");
      jQuery(".Modal--gwp").attr("aria-hidden", true);
    });
  });

  jQuery(document).on("click", ".swatch_color", function () {
    //jQuery(".swatch_color").click(function(){
    jQuery(document).find(".swatch_color").removeClass("swatch_selected");
    jQuery(this).addClass("swatch_selected");
    var imgid = jQuery(this).attr("prodimg");
    var product_url = jQuery(this).attr("data-url");
    var images = jQuery(document).find("#" + imgid).html();
    var pid = jQuery(this).attr("pid");
    var imagewrapper = jQuery(document).find("#product_" + pid + "_image_wrapper").html(images);
    if (product_url) {
      jQuery(document).find("#product_" + pid + "_image_wrapper").parents('.ProductItem__Wrapper').find('.update-url').attr('href', product_url);
    }
  });

  var $carousel = jQuery(".enabled--announcement-carousel").flickity({
    prevNextButtons: false,
    pageDots: false,
    watchCSS: false,
    autoPlay: 3000,
    pauseAutoPlayOnHover: false
  });
  setTimeout(function(){
    window.flkty = $carousel.data('flickity');
    var Anountop = parseFloat(window.flkty.maxCellHeight) + 24;
    jQuery("#shopify-section-header").css("top", Anountop + "px");
  },100);
  // if (jQuery(window).width() > 767 && jQuery(".enabled--announcement-carousel").hasClass('flickity-enabled')) {
  //   $carousel.flickity('destroy');
  // }
  

  // jQuery(window).resize(function (event) {
  //   if (jQuery(window).width() > 767 && jQuery(".enabled--announcement-carousel").hasClass('flickity-enabled')) {
  //     $carousel.flickity('destroy');
  //     var announcementHeight = $('#shopify-section-announcement').outerHeight(true);
  //     $('#shopify-section-header').css('top', announcementHeight + 'px');
  //   } else if (jQuery(window).width() < 768 && !jQuery(".enabled--announcement-carousel").hasClass('flickity-enabled')) {
  //     $carousel = jQuery(".enabled--announcement-carousel").flickity({
  //       prevNextButtons: false,
  //       pageDots: false,
  //       watchCSS: false,
  //       autoPlay: 3000,
  //       pauseAutoPlayOnHover: false
  //     });
  //   }
  // });
  // if (jQuery(window).width() > 767) {
  //   var announcementHeight = $('#shopify-section-announcement').outerHeight(true);
  //     $('#shopify-section-header').css('top', announcementHeight + 'px');
  // } else {
  //   setTimeout(function(){
  //     window.flkty = $carousel.data('flickity');
  //     console.log(window.flkty);
  //     var Anountop = parseFloat(window.flkty.maxCellHeight) + 24;
  //     console.log(Anountop);
  //     jQuery("#shopify-section-header").css("top", Anountop + "px");
  //   },100);
  // }

  
  jQuery(document).on('click', 'a[href^="#"]', function (e) {
    // target element id.
    var id = jQuery(this).attr('href');

    // target element.
    var $id = id !== '#' ? jQuery(id) : '';
    if (!$id || $id.length === 0) {
      return;
    }

    // prevent standard hash navigation (avoid blinking in IE).
    e.preventDefault();

    // top position relative to the document.
    var pos = $id.offset().top;

    // animated top scrolling.
    jQuery('body, html').animate({ scrollTop: pos }, 500);
  });
  
});

function handleWindow() {
  var body = document.querySelector('body');

  if (window.innerWidth > body.clientWidth + 5) {
    body.classList.add('has-scrollbar');
    body.setAttribute('style', '--scroll-bar: ' + (window.innerWidth - body.clientWidth) + 'px');
  } else {
    body.classList.remove('has-scrollbar');
  }
}

handleWindow();

$(document).on('click', '.product-modal', function (e) {
  e.preventDefault();
  $.fancybox.close();
  var url = $(this).attr('href');

  if (window.location.href.split("?").length >= 2) {
    let href = window.location.href.split("?")[0];
    window.history.pushState({ href: href }, '', href);
  }

  if (url) {
    $.fancybox.open(
      {
        src: url,
        opts: {
          type: 'ajax',
          smallBtn: false,
          baseClass: "fancybox-skin",
          touch: false,
          afterLoad: function (instance, current) {
            setTimeout(function () {
              $(document).find('.fancybox-content').scrollTop(0);
            }, 427);
          },
          beforeClose: function (e, instance) {
            if (typeof window.languages.productFormAddToCartMain != 'undefined') {
              window.languages.productFormAddToCart = window.languages.productFormAddToCartMain;
            }
          }
        }
      }
    );
  }

  return false;
});

$(document).ready( function(){
  function singularize(word) {
    const endings = {
        ies: 'y',
        i: 'us',
        zes: 'ze',
        ses: 's',
        rves: 'rf',
        es: 'e',
        s: ''
    };
    return word.replace(
        new RegExp(`(${Object.keys(endings).join('|')})$`), 
        r => endings[r]
    );
  }

  $(".no-plural").each(function(i, x){
    let text = $(x).text();
    $(x).text(singularize(text));
  });
});


function short_desktop_data($data, $sort_by) {
  if ($sort_by == '') {
      var sort_by = $('#filter [name="sort"]:checked').val();
      if ($(window).width() < 1140) {
          var currentUrl = new URL(location.href);
          var sort_by = currentUrl.searchParams.get('sort_by');
      }
  } else {
      var sort_by = $sort_by;
  }

  if (sort_by == 'manual' || !sort_by) {
      return $data;
  }
  var fiter_data = jQuery($data).filter('.selected_filter').clone();
  var prefine_data = jQuery($data).filter('*:not(.selected_filter)').clone();
  var sortedOtherItems = '';

  if (prefine_data.find('.plp-tile').length > 0) {
      var filter_items = prefine_data.find('.plp-tile');
      var additionalContentBlock = filter_items.filter('.additional-content-block');
      var otherItems = prefine_data.find('.plp-tile:not(.additional-content-block)');
      if ('title-ascending' == sort_by) {
          sortedOtherItems = otherItems.sort(function (a, b) {
              var compA = $(a).data('title').toUpperCase();
              var compB = $(b).data('title').toUpperCase();
              return (compA > compB) ? 1 : -1;
          });
      } else if ('title-descending' == sort_by) {
          sortedOtherItems = otherItems.sort(function (a, b) {
              var compA = $(a).data('title').toUpperCase();
              var compB = $(b).data('title').toUpperCase();
              return (compA < compB) ? 1 : -1;
          });
      } else if ('price-ascending' == sort_by) {
          sortedOtherItems = otherItems.sort(function (a, b) {
              var compA = parseFloat($(a).data('price'));
              var compB = parseFloat($(b).data('price'));
              return (compA > compB) ? 1 : -1;
          });
      } else if ('price-descending' == sort_by) {
          sortedOtherItems = otherItems.sort(function (a, b) {
              var compA = parseFloat($(a).data('price'));
              var compB = parseFloat($(b).data('price'));
              return (compA < compB) ? 1 : -1;
          });
      } else if ('created-ascending' == sort_by) {
          sortedOtherItems = otherItems.sort(function (a, b) {
              var compA = $(a).data('date');
              var compB = $(b).data('date');
              return (compA > compB) ? 1 : -1;
          });
      } else if ('created-descending' == sort_by) {
          sortedOtherItems = otherItems.sort(function (a, b) {
              var compA = $(a).data('date');
              var compB = $(b).data('date');
              return (compA < compB) ? 1 : -1;
          });
      }
  }

  if (sortedOtherItems != '') {
      // Create an array to store the sorted elements
      var sortedItems = [];

      var i = 0;
      // Loop through the original 'filter_items' and add them to 'sortedItems' in the sorted order
      filter_items.each(function (index, element) {
          if ($(element).hasClass('additional-content-block')) {
              // If the element has the 'additional-content-block' class, add it to the sorted items
              sortedItems.push(additionalContentBlock[0]);
          } else {
              // For other elements, add them in the sorted order
              sortedItems.push(sortedOtherItems[i]);
              i++;
          }
      });

      // Create an empty array to store the sorted HTML strings
      var sortedHtmlStrings = [];

      // Loop through the sortedItems array and convert each element to an HTML string
      $.each(sortedItems, function (index, element) {
          sortedHtmlStrings.push(element.outerHTML);
      });

      // Combine the HTML strings into one string
      var sortedHtml = sortedHtmlStrings.join('');

      var d = $('<div/>').append(prefine_data);
      d.find('.ProductList.ProductList--grid').empty();
      d.find('.ProductList.ProductList--grid').append(sortedHtml);
      return (fiter_data.length > 0 ? $('<div/>').append(fiter_data).html() : '') + d.html();
  }

  return $data;
}

jQuery(document).ready(function () {
  jQuery(document).on('click', '.filter_holder .inner-label', function() {
      if ($(this).hasClass('sub--open')) {
          jQuery('.filter_holder').removeClass('change--bg');
          jQuery('.filter_holder .inner-label').removeClass('sub--open');
      } else {
          jQuery('.filter_holder').removeClass('change--bg');
          jQuery('.filter_holder .inner-label').removeClass('sub--open');
          jQuery(this).addClass('sub--open');
          jQuery(this).parents('.filter_holder').addClass('change--bg');
      }
  });
  if (window.collection_url != '' || typeof window.collection_url != 'undefined') {
      $(document).on("click", ".btn_submit.filter_sort", function (e) {
        e.preventDefault();
        var filter_sort = $('#filter [name="sort"]:checked').val();
        if (!filter_sort) {
            $($('#filter [name="sort"]').get(0)).trigger('click');
        }

        filter_sort = $('#filter [name="sort"]:checked').val();

        var html = short_desktop_data($(".CollectionInner__Products .ProductListWrapper").html(), filter_sort);
        $(".CollectionInner__Products .ProductListWrapper").addClass("sorting__cls").html(html);
        $("#AjaxinatePagination a").attr('href', window.collection_url + '?page=1000');
        $("#AjaxinatePagination a").hide();
        $('.template-search .Pagination').remove();
        jQuery('.filter_holder .inner-label').removeClass('sub--open');
        $('.filter_holder').removeClass('change--bg');
        return false;
      });
  }
});